import {
  mdiTractor,
  mdiCallReceived,
  mdiImageMultiple,
  mdiMicrosoftExcel,
  mdiFactory,
  mdiPackageVariant,
  mdiSignatureFreehand,
  mdiClipboardCheckMultipleOutline,
  mdiCheckDecagram,
  mdiTruckDelivery,
} from '@mdi/js';

export default {
  data() {
    return {
      menuItems: [
        {
          name: 'menu.farms', pathName: 'processing-ListFarm', icon: mdiTractor, topMenu: false,
        },
        {
          name: 'menu.deliveryNotes', pathName: 'processing-ListDeliveryNote', icon: mdiTruckDelivery, topMenu: false,
        },
        {
          name: 'menu.stockItems', pathName: 'processing-ListStockItem', icon: mdiCallReceived, topMenu: true,
        },
        {
          name: 'menu.factoryItems', pathName: 'processing-ListFactoryItem', icon: mdiFactory, topMenu: true,
        },
        {
          name: 'menu.verify', pathName: 'processing-ListVerify', icon: mdiCheckDecagram, topMenu: true,
        },
        {
          name: 'menu.checkLists', pathName: 'checklists-Checklists', icon: mdiClipboardCheckMultipleOutline, topMenu: true,
        },
        {
          name: 'menu.brands', pathName: 'processing-ListBrand', icon: mdiImageMultiple, topMenu: false,
        },
        {
          name: 'menu.adminSignatures', pathName: 'processing-ListUserSignature', icon: mdiSignatureFreehand, topMenu: false,
        },
        {
          name: 'menu.stockTypes', pathName: 'processing-ListStockType', icon: mdiPackageVariant, topMenu: false,
        },
        {
          name: 'menu.processingData', pathName: 'processing-ListProcessingData', icon: mdiMicrosoftExcel, topMenu: true,
        },
      ],
    };
  },
};
